import { css } from 'lit';
import componentStyles from '../../styles/component.styles';
import { theme } from '../../themes/theme';
export default css `
    ${componentStyles}
    :host {
        ${theme.colors.cssColor('text-primary')};
    }

    .heading {
        ${theme.texts.cssHeading};
    }

    .subheading {
        ${theme.texts.cssSubtitle};
    }

    .subsubheading {
        ${theme.texts.cssBody('bold')};
    }

    .subsubsubheading {
        ${theme.texts.cssBody('semibold', "S")};
    }

    .default {
        ${theme.colors.cssBackground('secondary')};
        ${theme.spacings.cssPaddingX('S')};
        ${theme.spacings.cssPaddingY('XS')};
        border-radius: var(--sgdf-border-radius-large);
        color: var(--sgdf-color-default);
    }

    .neutral {
    }

    .container {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .actions {
        ${theme.texts.cssBody('normal')};
    }
`;
//# sourceMappingURL=heading.styles.js.map